import React, { InputHTMLAttributes, ReactNode, SelectHTMLAttributes, TextareaHTMLAttributes } from 'react';

import { Label } from '../../Label/Label';
import ValidationError from '../HtmlInput/ValidationError';

import styles from '../Fields.module.css';

type CommonFieldProps = InputHTMLAttributes<HTMLInputElement> &
  TextareaHTMLAttributes<HTMLTextAreaElement> &
  SelectHTMLAttributes<HTMLSelectElement>;
type FieldGroupColumnType = CommonFieldProps & {
  fieldId: string;
  FieldComponent?:
    | React.ComponentType<InputHTMLAttributes<HTMLInputElement> & { ref?: React.Ref<HTMLInputElement> }>
    | React.ComponentType<TextareaHTMLAttributes<HTMLTextAreaElement> & { ref?: React.Ref<HTMLTextAreaElement> }>
    | React.ComponentType<SelectHTMLAttributes<HTMLSelectElement> & { ref?: React.Ref<HTMLSelectElement> }>;
  label?: ReactNode;
  subLabel?: ReactNode;
  errorMessage?: string | ReactNode;
  errorWidth?: 'auto' | 'full';
  errorClass?: '';
  boxProps?: React.CSSProperties;
  children?: ReactNode;
};
function FieldGroupColumn({
  fieldId,
  label,
  subLabel,
  errorMessage,
  errorClass = '',
  errorWidth = 'auto',
  FieldComponent = undefined,
  boxProps = {},
  children = undefined,
  ...inputProps
}: FieldGroupColumnType) {
  const fieldProps = () => {
    const _inputPropKeys = Object.keys(inputProps);
    const _inputProps = { ...inputProps };
    if (!_inputPropKeys.includes('id')) _inputProps.id = fieldId;
    if (!_inputPropKeys.includes('name')) _inputProps.name = fieldId;
    if (!_inputPropKeys.includes('required')) _inputProps.required = inputProps.required;
    return _inputProps;
  };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', ...boxProps }}>
      {label && (
        <Label htmlFor={fieldId}>
          {label}
          {!inputProps?.required === true && (
            <>
              &nbsp;<small className={styles.optionalLabel}>Optioneel</small>
            </>
          )}
        </Label>
      )}
      {subLabel && (
        <small style={{ paddingBottom: '4px', color: 'var(--tractie-color-content-subtle)' }}>{subLabel}</small>
      )}
      {FieldComponent !== undefined && <FieldComponent {...fieldProps()} />}
      {children}
      <ValidationError errorMessage={errorMessage} className={errorClass} width={errorWidth} />
    </div>
  );
}
export default FieldGroupColumn;
